import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";

import type { BacklinkExpectedURLParams } from "../shared/BacklinksTypes";

export const onRedirectBacklinksKey: transitionHookFn = (transition) => {
    const params: BacklinkExpectedURLParams = transition?.params() ?? {};
    const { key = "" /* pageFilter */ } = params;
    if (key.includes(",")) {
        return {
            params: {
                ...params,
                key: key.split(",").shift(),
            },
        };
    }

    return void 0;
};
